<template>
    <div style="  background: #eeeeee;height: 100vh;">
        <div class="wrap">
            <div class="walletTop">
                <van-icon name="arrow-left" color="#fff" size="25" @click="$router.go(-1)" />
                <div class="topTitle">
                    <div>
                        今日积分
                    </div>
                </div>
                <div class="topNum">
                    <div>
                        {{balance}}
                    </div>
                    <div>
                        今日积分(元)
                    </div>
                </div>
            </div>
            <!-- 列表 -->
            <div class="recordList" v-if='list.length>0'>
                <div class="recordItem" v-for="(item,index) in list" :key="index">
                    <div class="itemLeft" style="width: 100%;">
                        <div class="itemMoney">
                            币种名称:
                            <span>{{item.currency_name}}</span>
                        </div>
                        <div class="itemMoney">
                            备注:
                            <span>{{item.bill_type}}</span>
                        </div>
                        <div class="itemMoney">
                            金额:
                            <span>{{item.account}}</span>
                        </div>
                        <div class="itemMoney"> <span>时间:{{item.create_time}}</span></div>
                    </div>
                </div>
            </div>
            <div v-else class="noData">
                <p>暂无数据</p>
            </div>
        </div>
    </div>
</template>

<script>
    import { billRecord, todayBillRecord } from "@/api/personal";

    export default {
        data() {
            return {
                balance: 0,
                list: []
            };
        },
        created() {
            billRecord().then(res => {
                this.balance = res.today_account;
            })
            this.getList();
        },
        methods: {
            getList() {
                todayBillRecord().then(res => {
                    this.list = res;
                })
            },
        }
    };
</script>
<style lang='less' scoped>
    .wrap {
        height: 100%;
        background: #eeeeee;

        .walletTop {
            width: 100%;
            height: 254.5px;
            background: #2B83F5;
            color: #FEFEFE;
            font-size: 18px;
            padding-top: 14.5px;
            box-sizing: border-box;

            .topTitle {
                display: flex;
                margin-bottom: 26.5px;

                div {
                    &:first-child {
                        background: #4FB7FE;
                        font-size: 15px;
                        border-radius: 0px 13.25px 13.25px 0px;
                        margin-right: 9px;
                        height: 26.5px;
                        line-height: 26.5px;
                    }

                }
            }

            .topNum {
                text-align: center;

                div {
                    &:first-child {
                        margin-bottom: 23.5px;
                        font-size: 53px;
                    }
                }
            }
        }

        .recordList {
            width: 345px;
            border-radius: 8px;
            background: #fff;
            box-sizing: border-box;
            padding: 0 13px;
            margin: 10px auto 0;

            .recordItem {
                display: flex;
                justify-content: space-between;
                color: #666666;
                padding: 14.5px 0 12.5px;
                border-bottom: 1px solid #c1c1c1;
                font-size: 13px;

                .itemtype {
                    color: #343434;
                }

                .itemMoney {
                    margin-top: 11.5px;

                    span {
                        color: #343434;
                    }
                }

                .itemRight {
                    text-align: right;

                    .itemStatus {
                        font-size: 16px;
                    }

                    .itemTime {
                        margin-top: 10px;
                    }
                }
            }
        }
    }
</style>